"use client";

import { c as _c } from "react-compiler-runtime";
import { Camera } from "lucide-react";
import { motion } from "motion/react";
import { Text } from "@/components/primitives";
import { Button } from "@/components/ui/button";
type CaptureHeaderProps = {
  title?: string;
  onBack?: () => void;
  liveBadgeText?: string | null;
};
export function CaptureHeader(t0) {
  const $ = _c(13);
  const {
    title,
    onBack,
    liveBadgeText
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 1,
      y: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      y: -20
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onBack) {
    t3 = onBack ? <Button className="border-white/20 text-white/80 hover:border-white/40 hover:text-white" size="icon" type="button" variant="outline" onClick={onBack}><svg fill="none" height="20" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m15 18-6-6 6-6" /></svg></Button> : null;
    $[2] = onBack;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex w-10 shrink-0 items-center">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== liveBadgeText || $[7] !== title) {
    t5 = title || liveBadgeText ? <div className="text-overlay-foreground/60 mx-2 flex min-w-0 flex-1 items-center justify-center gap-1.5 text-[11px] sm:gap-2 sm:text-xs">{title ? <Camera className="h-3.5 w-3.5" /> : null}{title ? <span className="whitespace-nowrap"><Text component="span" text={title} variant="caption" /></span> : null}{liveBadgeText ? <span className="bg-accent/20 text-accent ml-1 rounded px-1.5 py-0.5 text-[10px]"><Text component="span" text={liveBadgeText} variant="caption" /></span> : null}</div> : <div className="mx-2 min-w-0 flex-1" />;
    $[6] = liveBadgeText;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-10 shrink-0" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5) {
    t7 = <motion.div animate={t1} className="section-container relative z-10 flex w-full items-center px-3 py-3 sm:px-4" initial={t2}>{t4}{t5}{t6}</motion.div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}